import React from "react";
import Icon from "@ant-design/icons";
import type { CustomIconComponentProps } from "@ant-design/icons/lib/components/Icon";

const CriyaIsotypeSvg = () => (
  <svg
    width='1em'
    height='1.143em'
    viewBox='0 0 35 40'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M27.4453 26.9502C31.2236 26.9502 34.2866 30.0131 34.2866 33.7915C34.2866 37.2203 31.507 39.9998 28.0782 39.9998L27.2085 39.9998C22.9009 39.9998 19.4089 36.5078 19.4089 32.2002L19.4089 26.9502L27.4453 26.9502Z'
      fill='url(#paint0_linear_223_13465)'
    />
    <path
      d='M17.7302 6.73841C17.7302 3.01689 14.7133 0 10.9918 0H9.39462C4.20616 0 8.39233e-05 4.20608 8.39233e-05 9.39454C8.39233e-05 13.9514 3.69412 17.6454 8.25094 17.6454H17.7302V6.73841Z'
      fill='url(#paint1_linear_223_13465)'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M9.59364 19.3467H17.7316V32.2261C17.7316 36.5191 14.301 39.9992 10.0691 39.9992H2.68615C1.20344 39.9992 0.00146484 38.7799 0.00146484 37.2758V29.0772C0.00146484 23.7032 4.29603 19.3467 9.59364 19.3467ZM1.67006 29.7414C2.18138 26.477 4.32192 23.1824 8.19542 22.3361C8.32439 22.3079 8.20272 22.3863 7.91182 22.5739C6.79138 23.2965 3.16031 25.6381 1.67006 29.7414Z'
      fill='url(#paint2_linear_223_13465)'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M26.8478 0C22.7394 0 19.4089 3.37851 19.4089 7.5461V25.2482H29.868C32.3083 25.2482 34.2866 23.2415 34.2866 20.766V7.5461C34.2866 3.37851 30.9561 0 26.8478 0ZM21.7582 11.2287C21.8074 7.20339 21.8576 3.10388 26.4301 1.57171C22.4797 3.59254 22.0691 8.9911 21.8416 11.9819C21.7969 12.5698 21.7592 13.0647 21.7032 13.4225C21.7402 12.7047 21.7492 11.9679 21.7582 11.2287Z'
      fill='url(#paint3_linear_223_13465)'
    />
    <defs>
      <linearGradient
        id='paint0_linear_223_13465'
        x1='13.3812'
        y1='25.3558'
        x2='13.4502'
        y2='34.3574'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#A98273' />
        <stop offset='0.520833' stopColor='#C6978C' />
        <stop offset='1' stopColor='#D8B8AB' />
      </linearGradient>
      <linearGradient
        id='paint1_linear_223_13465'
        x1='20.0236'
        y1='6.12257'
        x2='8.35195'
        y2='-1.87146'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#819585' />
        <stop offset='0.396113' stopColor='#91A999' />
        <stop offset='1' stopColor='#ADC8B6' />
      </linearGradient>
      <linearGradient
        id='paint2_linear_223_13465'
        x1='15.5229'
        y1='15.4237'
        x2='23.0447'
        y2='37.7526'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#C1BDB4' />
        <stop offset='0.396113' stopColor='#DED6C7' />
        <stop offset='1' stopColor='#F5F3EE' />
      </linearGradient>
      <linearGradient
        id='paint3_linear_223_13465'
        x1='17.4845'
        y1='8.76059'
        x2='29.874'
        y2='3.78428'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#D58405' />
        <stop offset='0.396113' stopColor='#F39C12' />
        <stop offset='1' stopColor='#EEB457' />
      </linearGradient>
    </defs>
  </svg>
);

export const CriyaIsotypeIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={CriyaIsotypeSvg} {...props} />
);
